import { Link } from "react-router-dom";

const MAIN_SITE = "https://www.burgerlijk.com";

export default function SiteFooter() {
  return (
    <footer className="bg-bl-black text-white">
      <div className="page-container grid gap-10 py-14 md:grid-cols-[1.4fr_1fr_1fr]">
        <div className="space-y-4">
          <img src="/images/logo_white.png" alt="Burgerlijk" className="h-14 w-auto" />
          <p className="max-w-sm text-sm text-white/70">
            Onze foodtruck bakt Burgerlijk-burgers op jouw feest, huwelijk, communie of bedrijfsevent. Premium is het minimum.
          </p>
        </div>

        <div className="space-y-4 text-sm">
          <div>
            <p className="text-xs uppercase tracking-widest text-white/50">Mail</p>
            <a href="mailto:ontour@burgerlijk.com" className="font-bold hover:text-bl-gold">
              ontour@burgerlijk.com
            </a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-white/50">Adres</p>
            <p className="font-bold">
              Comm. Edm. Ameyestraat 4
              <br />
              8540 Deerlijk
            </p>
          </div>
        </div>

        <nav className="space-y-2 text-sm" aria-label="Footer">
          <p className="text-xs uppercase tracking-widest text-white/50">Burgerlijk</p>
          <a href={`${MAIN_SITE}/`} className="block text-white/80 hover:text-white">
            burgerlijk.com
          </a>
          <a href={`${MAIN_SITE}/burger-box`} className="block text-white/80 hover:text-white">
            De Burger Box
          </a>
          <a href={`${MAIN_SITE}/zonder-ende`} className="block text-white/80 hover:text-white">
            Zonder Ende
          </a>
          <Link to="/privacy-policy" className="block text-white/80 hover:text-white">
            Privacybeleid
          </Link>
        </nav>
      </div>

      <div className="border-t border-white/10">
        {/* The year follows the calendar, so it never needs a manual update */}
        <p className="page-container flex flex-wrap items-center justify-center gap-x-3 gap-y-1 py-5 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Burgerlijk</span>
          <span aria-hidden="true">|</span>
          <span>
            Made with <span className="text-bl-red">♥</span> in Deerlijk -{" "}
            <a href="https://glue.blue" target="_blank" rel="noopener noreferrer" className="underline hover:text-white">
              glue.blue
            </a>
          </span>
        </p>
      </div>
    </footer>
  );
}
